.sectionIcon {
    img {
        width: 32px;
        height: 32px;
        filter: brightness(0) saturate(100%) invert(79%) sepia(7%) saturate(495%) hue-rotate(14deg) brightness(96%) contrast(90%);
    }

    margin-right: 8px;
    object-fit: contain;
    display: inline-block;
}

.noDataAvail {
    font-size: 20px;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #102442;
    text-align: center;
    padding: 10px;
}

.panelTableStyleRelativeContainer {
    position: relative;
    height: 20px;
}

.dealCategoryScore {
    transform: scale(0.7) !important;
}
.panelTableStyleScoreLine {
    position: absolute;
    top: -12px;
    width: 100%;
    height: 50px;
    //--panel-table-auto-row-width: minmax(auto, 600px);
    --panel-table-label-column-width: 500px;
    --panel-table-gap: 20px;
    > [class*='even_row'] {
        background-color: transparent;
        border: none !important;
    }

    > [class*='odd_row'] {
        background-color: transparent;
        border: none !important;
    }

    z-index: 50000;
}

.panelTableStyle {
    --panel-table-label-column-width: 500px;
    --panel-table-gap: 20px;
    > [class*='grid_row_1'] {
        padding-top: 18px;
    }

    > [class*='even_row'] {
        background-color: #fcfcfd;
        border: none !important;
    }

    > [class*='odd_row'] {
        background-color: #f1f3f6;
        border: none !important;
    }

    *[class*='rowValue'] {
        text-align: center;
        font-family: Hanken Grotesk;
        font-weight: 400;
        color: #102442;
    }
}

.dealThumbScore {
    position: absolute;
    top: -20;
}

.panelTableCompanies {
    *[class*='grid_row_1 '] {
        background-color: transparent !important;
    }
}

.companyLogo {
    width: 80%;
    max-height: 80px;
    object-fit: contain;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
}

.companyHeaderElement {
    position: relative;
    background-color: white;
    border-radius: 20px;
    height: 200px;
    width: calc(100% - 40px);
    margin: 20px 20px;
    padding: 20px;
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));
    transition: transform 0.2s ease, filter 0.2s ease;
    
    &:hover:not(.industryCard) {
        transform: translateY(-2px);
        filter: drop-shadow(0px 6px 15px rgba(0, 0, 0, 0.15));
    }
}

.industryCard {
    background-color: rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(209, 213, 219, 0.3) !important;
    
    .companyLogo {
        width: 50%;
        max-height: 45px;
        opacity: 0.8;
        filter: grayscale(20%);
    }
    
    .companyNameLabel {
        font-size: 16px;
        font-weight: 700;
        margin-top: 12px;
        margin-bottom: 0;
        color: rgba(16, 36, 66, 0.8);
        line-height: 1.3;
        text-align: center;
        width: 100%;
    }
    
    .industrySubType {
        font-size: 14px;
        font-weight: 400;
        color: rgba(16, 36, 66, 0.6);
        margin-top: 2px;
        text-align: center;
        width: 100%;
    }
}

.companyNameLabel {
    font-size: 16px;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #102442;
    text-align: center;
    margin-bottom: 8px;
}

.dealScoreCard {
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.industryScore {
    background-color: #F3F4F6 !important;
}

.diamondIcon {
    color: #D4D9E0;
    font-size: 12px;
    margin: 0;
}

.dealThumbScore {
    position: absolute;
    top: -20px;
}

.panelTitleText {
    font-size: 28px !important;
    font-style: italic !important;
    font-weight: 500 !important;
    font-family: 'Lust Text', serif !important;
    color: #475467 !important;
    text-align: left !important;
}

.panelTitle {
    padding-top: 40px !important;
    padding-bottom: 15px !important;
    background-color: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    position: relative !important;

    &:not(:first-child)::before {
        content: '';
        position: absolute;
        top: 20px;
        left: 0;
        right: 0;
        height: 1px;
        background-image: linear-gradient(
            to right,
            black 33%,
            rgba(255, 255, 255, 0) 0%
        );
        background-position: top;
        background-size: 10px 1px;
        background-repeat: repeat-x;
        z-index: 1;
    }
    
    &:first-child {
        padding-top: 20px !important;
    }
}

.cardContainer {
    position: relative;
    width: 100%;
    height: 100%;
}

.removeButton {
    position: absolute;
    top: -12px;
    right: 8px;
    background: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    z-index: 2;
    transition: all 0.2s ease;
    padding: 0;
    
    &:hover {
        background: #ffeeee;
        transform: scale(1.1);
    }

    i {
        font-size: 14px;
    }
}

.addCardButton {
    background: white;
    border: 2px dashed #0066FF;
    border-radius: 20px;
    width: calc(100% - 40px);
    height: 200px;
    margin: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        background: #f5f9ff;
        transform: scale(1.02);
    }
}

.addCardText {
    margin-top: 12px;
    font-family: Hanken Grotesk;
    font-size: 16px;
    color: #0066FF;
}

.industrySection {
    display: grid;
    grid-template-columns: var(--panel-table-label-column-width) 1fr;
    gap: var(--panel-table-gap);
    padding: 16px 0;
    border-top: 1px solid #E5E7EB;
    margin-top: 20px;
}

.industryLabel {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #102442;
    font-size: 16px;
}

.industryIcon {
    width: 24px;
    height: 24px;
}

.industryValues {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--panel-table-gap);
    align-items: center;
}

.industryValue {
    text-align: center;
    font-family: Hanken Grotesk;
    font-weight: 400;
    color: #102442;
    font-size: 14px;
}
